import { Component, OnInit } from '@angular/core';
import { Suggestion } from '@model/Suggestion';
import { Paginate } from '@model/admin/paginate';
import { PageEvent, MatTableDataSource } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SuggestionService } from '@service/admin/suggestions.service';
import { ToastrService } from 'ngx-toastr';
import { Message } from '@model/Message';

@Component({
  selector: 'app-user-suggestions',
  templateUrl: './user-suggestions.component.html',
  styleUrls: ['./user-suggestions.component.scss']
})
export class UserSuggestionsComponent implements OnInit {

  public displayedColumns: string[] = ['message', 'public'];
  public pageEvent: PageEvent;
  public page: Paginate<Suggestion> = {
    per_page: 20,
    current_page: 0,
    totalElements: 0
  } as Paginate<Suggestion>;
  public dataSource = new MatTableDataSource<any>();
  public pageSizeOptions: number[] = [5, 10, 20];
  public formSuggestionAnswer: FormGroup[] = [];
  
  constructor(
    private fb: FormBuilder,
    private suggestionService: SuggestionService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.getSuggestions({ previousPageIndex: 0, pageIndex: this.page.current_page, pageSize: this.page.per_page, length: this.page.totalElements });
  }

  transformDate(datetime){
    let transform;
    transform = datetime.split('.')[0].split('T');
    let date = transform[0].split('-').reverse();
    let time = transform[1];
    return '  ' + date[0] + '/' + date[1] + '/' + date[2] + ' -  ' + time;
  }

  getSuggestions(event?: PageEvent): PageEvent {
    this.suggestionService.get(event.pageSize, event.pageIndex + 1, true)
    .subscribe(
      (response: Paginate<Suggestion>) => {
        this.page = {...this.page, totalPages: response.totalPages, totalElements: response.totalElements};
        response.data.forEach(element => {
          element['reply'] = false;
          element.created_at = this.transformDate(element.created_at);
          //@ts-ignore
          if(element.suggestions_answers){
            //@ts-ignore
            if(element.suggestions_answers[element.suggestions_answers.length-1]){
              //@ts-ignore
              if(element.user.id == element.suggestions_answers[element.suggestions_answers.length-1].user.id){
                element['reply'] = false;
              }
              else{
                element['reply'] = true;
              }
            }
            //@ts-ignore
            element.suggestions_answers.forEach(sugg_answer =>{
              sugg_answer.created_at = this.transformDate(sugg_answer.created_at);
              //@ts-ignore
              if(sugg_answer.user.id == element.user.id){
                sugg_answer['color'] = 'color-escritha';
              }
              else{
                sugg_answer['color'] = 'color-orange';
              }
            });
          }
        });
        this.dataSource.data = response.data;
        if(response.data){
          response.data.forEach(element => {
            this.formSuggestionAnswer.push(this.fb.group({
              answer: ['', Validators.compose([
                Validators.required
              ])],
              //@ts-ignore
              public: [element.public, Validators.compose([
                Validators.required
              ])]
            }));
          });
        }
      }
    );
    return event;
  }

  saveAnswer(i, suggestion_id){
    let data = {
      message: this.formSuggestionAnswer[i].value.answer,
      suggestion_id: suggestion_id
    };
    this.suggestionService.saveAnswer(data).subscribe(res => {
      this.getSuggestions({ previousPageIndex: 0, pageIndex: this.page.current_page, pageSize: this.page.per_page, length: this.page.totalElements });
    });
  }

}
